module.exports = __webpack_public_path__ + "img/04.60949796.jpg";